module.exports = __webpack_public_path__ + "static/media/DAI-logo.662e0cc6.png";